module.exports = __webpack_public_path__ + "img/on-the-move.64bd08da.svg";